import Section from 'pages/LandingPage/Sections/Section/Section';

export default Section;
